import { render, staticRenderFns } from "./userDetailDrawer.vue?vue&type=template&id=9fc3a67e&scoped=true"
import script from "./userDetailDrawer.vue?vue&type=script&lang=js"
export * from "./userDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./userDetailDrawer.vue?vue&type=style&index=0&id=9fc3a67e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc3a67e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/adam/Documents/Private_Repository/sjtx/backendAdmin/sjtx_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fc3a67e')) {
      api.createRecord('9fc3a67e', component.options)
    } else {
      api.reload('9fc3a67e', component.options)
    }
    module.hot.accept("./userDetailDrawer.vue?vue&type=template&id=9fc3a67e&scoped=true", function () {
      api.rerender('9fc3a67e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/ai/components/userDetailDrawer.vue"
export default component.exports